import {Poi, Trip} from '../../react-app-env';
import React, {ReactNode} from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {noop} from '../../utils/Utils';
import {getPoiCategoryIconCategory} from '../../utils/PoiCategoryUtils';
import {PoiMetaData} from '../../services/MetaDataService';
import HeaderImage from './HeaderImage';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';
import Icon, {IconSizes} from '../icon/Icon';

export interface GeneralGroupProps {
  trip: Trip;
  poi: Poi;
  metaData: PoiMetaData | null;
  onPoiCategoryClicked: () => void;
  onPoiGroupClicked: () => void;
}

const GeneralGroup: React.FunctionComponent<GeneralGroupProps> = (
    {
      trip,
      poi,
      metaData,
      onPoiCategoryClicked,
      onPoiGroupClicked
    }
) => {
  const poiGroup = trip.poiGroups?.find(group => group.id === poi.groupId)!;
  const iconCategory = getPoiCategoryIconCategory(poi.category);
  const iconCategoryLabel = i18n().poiCategories[poi.category];
  const thumbnailImage = poi.imageUrl ?? metaData?.thumbnailUrl;

  function renderRatingListViewItem(): ReactNode {
    const rating = metaData?.rating;
    if (rating == null) {
      return null;
    }

    const stars = Array.from({ length: 5 }, (_, i) => {
      const value = i + 1;
      if (rating >= value) {
        return <Icon key={value}
                     size={IconSizes.SMALL}
                     category="fa-star"/>;
      } else if (rating >= value - 0.5) {
        return <Icon key={value}
                     size={IconSizes.SMALL}
                     category="fa-star-half-stroke"/>;
      } else {
        return <Icon key={value}
                     size={IconSizes.SMALL}
                     category="fa-star fa-regular"/>;
      }
    });

    const label = i18n().poiDetails.general.ratingsDescription
                      .replace('%rating%', rating.toString() ?? 'Unknown')
                      .replace('%count%', formatRatingsCount());

    return <ListViewItem title={stars}
                         bottomAffix={{ label: label }}/>;
  }

  function formatRatingsCount() {
    const count = metaData?.ratingsCount || 0;
    if (count > 1000000) {
      return Math.round(count / 100000) / 10 + 'm';
    } else if (count > 1000) {
      return Math.round(count / 100) / 10 + 'k';
    } else {
      return count.toString()
    }
  }

  return <ListViewGroup className={'general-group'}>
    {thumbnailImage && <HeaderImage poi={poi}
                                    metaData={metaData}/>}
    {renderRatingListViewItem()}
    <ListViewItem title={iconCategoryLabel}
                  iconCategory={iconCategory}
                  decoration={DefaultItemDecorations.CHEVRON}
                  onClick={() => onPoiCategoryClicked()}/>
    <ListViewItem title={poiGroup.title}
                  iconCategory="fa-folder fa-regular"
                  decoration={DefaultItemDecorations.CHEVRON}
                  onClick={() => onPoiGroupClicked()}/>
    <ListViewItem title={i18n().poiDetails.general.customizeImage}
                  iconCategory={'fa-image fa-regular'}
                  decoration={DefaultItemDecorations.EDIT}
                  onClick={() => noop()}/>
  </ListViewGroup>;
};

export default GeneralGroup;
